module.exports = __webpack_public_path__ + "img/2.1f0c0211.png";